import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, UrlTree } from '@angular/router';
import { catchError, map, Observable, of } from 'rxjs';

import { AuthService } from './auth.service';
import { Permission } from './models';
import { TokenStorageService } from './token-storage.service';

export const authGuard: CanActivateFn = (): boolean | UrlTree => {
  const tokenStorage = inject(TokenStorageService);
  const router = inject(Router);

  return tokenStorage.hasToken() ? true : router.createUrlTree(['/login']);
};

export const permissionGuard: CanActivateFn = (route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const requiredPermissions = route.data['permissions'] as Permission[] | undefined;

  return authService.ensureProfile().pipe(
    map((profile) => {
      if (!profile) {
        return router.createUrlTree(['/login']);
      }
      return authService.hasAnyPermission(requiredPermissions) ? true : router.createUrlTree(['/forbidden']);
    }),
    catchError(() => of(router.createUrlTree(['/login'])))
  );
};
